export default __webpack_public_path__ + "static/media/pearl.b9dfa57e.png";